import script from "./CustomToaster.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomToaster.vue?vue&type=script&lang=ts&setup=true"

import "./CustomToaster.vue?vue&type=style&index=0&id=351b67d7&lang=css"
import "./CustomToaster.vue?vue&type=style&index=1&id=351b67d7&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351b67d7"]])

export default __exports__